const m15Section = {
  id: 'm15',
  name: '2027ScoresheetM15Sub1Label',
  fields: [
    {
      scoring: '2027ScoresheetM15Sub2Label',
      id: 'm15_scoring_1',
      options: [
        {
          description: 'noLabel',
          value: false
        },
        {
          description: 'yesLabel',
          value: true
        }
      ]
    },
    {
      scoring: '2027ScoresheetM15Sub3Label',
      id: 'm15_scoring_2',
      options: [
        {
          description: 'noLabel',
          value: false
        },
        {
          description: 'yesLabel',
          value: true
        }
      ]
    },
    {
      scoring: '2027ScoresheetM15Sub4Label',
      id: 'm15_scoring_3',
      options: [
        {
          description: 'noLabel',
          value: false
        },
        {
          description: 'yesLabel',
          value: true
        }
      ]
    },
    {
      scoring: '2027ScoresheetM15Sub5Label',
      id: 'm15_scoring_4',
      options: [
        {
          description: 'mineLabel',
          value: 1
        },
        {
          description: 'cityLabel',
          value: 2
        },
        {
          description: 'farmLabel',
          value: 3
        }
      ]
    }
  ]
}

export default m15Section;

